module.exports = __webpack_public_path__ + "assets/img/c2.9583c225.jpg";